import { api } from './api';
import { Client, ClientStatus, InvoiceStatus } from '../types';

export interface CreateClientRequest {
  firstName: string;
  lastName: string;
  email?: string;
  phone?: string;
  address?: {
    street?: string;
    city?: string;
    state?: string;
    postalCode?: string;
  };
  notes?: string;
  status?: ClientStatus;
}

export interface UpdateClientRequest extends Partial<CreateClientRequest> {}

export interface ClientBalanceResponse {
  clientId: string;
  totalBalance: number;
  availableCredit: number;
  invoices: Array<{
    invoiceId: string;
    invoiceNumber: string;
    total: number;
    balanceDue: number;
    status: InvoiceStatus;
  }>;
}

export const clientsApi = {
  list: async (status?: ClientStatus): Promise<{ clients: Client[]; count: number }> => {
    const params = status ? `?status=${status}` : '';
    return api.get<{ clients: Client[]; count: number }>(`/clients${params}`);
  },

  get: async (id: string): Promise<Client> => {
    return api.get<Client>(`/clients/${id}`);
  },

  create: async (data: CreateClientRequest): Promise<Client> => {
    return api.post<Client>('/clients', data);
  },

  update: async (id: string, data: UpdateClientRequest): Promise<Client> => {
    return api.put<Client>(`/clients/${id}`, data);
  },

  invite: async (id: string): Promise<{ message: string; invitedAt: string }> => {
    return api.post<{ message: string; invitedAt: string }>(`/clients/${id}/invite`, {});
  },

  getBalance: async (id: string): Promise<ClientBalanceResponse> => {
    return api.get<ClientBalanceResponse>(`/clients/${id}/balance`);
  },
};
